/**
 * A mixin to add to a component to be able to set v-model on it
 * After adding this to a component, use the `input` attribute as the model of the component
 * when the input data attribute is changed, the data on the v-model in the parent will change as well
 */

import uid from './uid'

export default {
  mixins: [uid],
  props: {
    value: {
      required: false,
    },
    /**
     * The title of the edit block to be displayed next to it
     */
    title: {
      required: false,
      type: String,
      default: '',
    },
    /**
     * The title of the edit block to be displayed next to it
     */
    inlineTitle: {
      required: false,
      type: Boolean,
      default: false,
    },
    deactivated: {
      required: false,
      type: Boolean,
      default: false,
    },
    /**
     * Enables a popover with additional information
     */
    popoverContent: {
      required: false,
      type: String,
      default: '',
    },
  },
  data() {
    return {
      input: null,
    }
  },
  created() {
    this.input = this.value
  },
  watch: {
    input(val) {
      // Prevent emit if not needed
      if (val !== this.value) {
        this.$emit('input', val)
      }
    },
    value(newVal) {
      this.input = newVal
    },
  },
  methods: {
    onBlur() {
      this.$emit('blur', this.input)
    },
    onChange() {
      this.$emit('change', this.input)
    },
  },
}
